import { render, staticRenderFns } from "./PRJ911P01.vue?vue&type=template&id=2bf88218&"
import script from "./PRJ911P01.vue?vue&type=script&lang=js&"
export * from "./PRJ911P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports